import { Injectable } from '@angular/core';
import { translate } from '@ngneat/transloco';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ISiteBuilderCartPromos, ISiteBuilderDynamicPrices, ISiteBuilderPack, ISiteBuilderPackCard, ISiteBuilderPeriodCard, ISiteBuilderPrices } from './site-builder';

@Injectable()
export class SiteBuilderService {

  packOptions = [
    {
      id: 0,
      title: 'Blog & Articles',
      funcList: [
        'Blog & Articles',
        'Bloc personnalises',
        'Gestion des utilisateurs avec droits (contributeurs, rewievers,...)',
      ],
    },
    {
      id: 1,
      title: 'Outils Marketing basiques',
      funcList: [
        'Creation de formulaires',
        'Integration d\'une newsletters',
        'Integration des reseaux sociaux',
      ],
    },
    {
      id: 2,
      title: 'Outils SEO',
      funcList: [
        'Google Analytics',
        'Parametres SEO',
        'Statistiques avancees',
      ],
    },
    {
      id: 3,
      title: 'Outils Marketing avances',
      funcList: [
        'Google Tag Manager (GTM)',
        'Integration d\'apps',
        'Creation de modales (pop-up)',
        'Code embarque (HTML5, CSS...)',
        'Support de plugins',
      ],
    },
    {
      id: 4,
      title: 'Outils de design',
      funcList: [
        'Createur de logo',
        'Polices personnalisables',
        'Outils pour Designer',
        'Effet (parrallax, animations...)',
        'Elements avances',
      ],
    },
    {
      id: 5,
      title: 'Boutique en ligne',
      funcList: [
        'Gestion des produits',
        'Gestion des livraisons',
        'Gestion de l\'inventaire',
        'Paiement securise (Stripe, Paypal)',
      ],
    },
    {
      id: 6,
      title: 'Systeme de paiement',
      funcList: [
        'Stripe',
        'Paypal',
        'PostFinance',
        'American Express',
        'Revolut,..',
      ],
    },
    {
      id: 7,
      title: 'Gestion des versions',
      funcList: [
        'Gerez et restaurez les versions des pages de votre site internet',
      ],
    }
  ];

  getPackSwiperConfig(): SwiperConfigInterface {
    return {
      direction: 'horizontal',
      slidesPerView: 3,
      loop: false,
      breakpoints: {
        // when window width is <= px
        760: {
          slidesPerView: 1
        },
        1366: {
          slidesPerView: 2
        },
      },
      threshold: 20,
      keyboard: true,
      mousewheel: false,
      scrollbar: false,
      navigation: {
        nextEl: '.next-step1',
        prevEl: '.prev-step1'
      },
      pagination: false,
      normalizeSlideIndex: true,
      watchOverflow: true,
    };
  }

  getPeriodSwiperConfig(): SwiperConfigInterface {
    return {
      direction: 'horizontal',
      slidesPerView: 4,
      loop: false,
      breakpoints: {
        // when window width is <= px
        760: {
          slidesPerView: 1
        },
        1366: {
          slidesPerView: 2
        },
      },
      threshold: 20,
      keyboard: true,
      mousewheel: false,
      scrollbar: false,
      navigation: {
        nextEl: '.next-step3',
        prevEl: '.prev-step3'
      },
      pagination: false,
      normalizeSlideIndex: true,
      watchOverflow: true,
    };
  }

  getSiteBuilderPackCard(packs: ISiteBuilderPack, prices: ISiteBuilderPrices): ISiteBuilderPackCard[] {
    return [
      // FREE
      {
        id: 1,
        name: 'offer_' + packs[0].name,
        price: this.getPrice(prices, 'pack', 1),
        optionList: [
          translate('<strong>$num$</strong> pages maximum', { num: '10' }),
          translate('Modeles <strong>illimite</strong>')
        ],
        list: [
          {
            description: translate('Modeles prets a l\'emploi')
          },
          {
            description: translate('Jusqu\'a 10 pages')
          },
          {
            description: translate('3 brouillons')
          },
          {
            description: translate('Certificat SSL gratuit')
          },
          {
            description: translate('Outils Marketing basiques'),
            tooltip: 1,
          }
        ],
        isStared: false,
      },
      // CLASSIC
      {
        id: 2,
        name: 'offer_' + packs[1].name,
        price: this.getPrice(prices, 'pack', 2),
        optionList: [
          translate('Nombre de page <strong>illimite</strong>'),
          translate('Modeles <strong>illimite</strong>')
        ],
        list: [
          {
            description: translate('Offre $offer$ incluse', { offer: 'Free' }),
            img: 'pack_1',
          },
          {
            description: translate('Blog & Articles')
          },
          {
            description: translate('Blocs personnalises')
          },
          {
            description: translate('Gestion d\'utilisateurs avec droits personnalises')
          },
          {
            description: translate('Outils SEO'),
            tooltip: 2,
          },
        ],
        isStared: true,
      },
      // PRO
      {
        id: 3,
        name: 'offer_' + packs[2].name,
        price: this.getPrice(prices, 'pack', 3),
        optionList: [
          translate('Nombre de page <strong>illimite</strong>'),
          translate('Modeles <strong>illimite</strong>')
        ],
        list: [
          {
            description: translate('Offre $offer$ incluse', { offer: 'Essential' }),
            img: 'pack_2'
          },
          {
            description: translate('Gestion des versions'),
            tooltip: 7,
          },
          {
            description: translate('Site multilingue')
          },
          {
            description: translate('Outils de design'),
            tooltip: 4,
          },
          {
            description: translate('Outils Marketing avances'),
            tooltip: 3,
          },
        ],
        isStared: false,
      },
      // ESHOP LIGHT
      {
        id: 4,
        name: 'offer_' + packs[3].name,
        price: this.getPrice(prices, 'pack', 4),
        optionList: [
          translate('Jusqu\'a <strong>$num$</strong> produits', { num: '15' }),
          translate('Modeles <strong>e-commerce</strong>')
        ],
        list: [
          {
            description: translate('Compatible tous supports'),
          },
          {
            description: translate('Historique des commandes')
          },
          {
            description: translate('Estimation d\'expedition en temps reel')
          },
        ],
        isStared: false,
      },
      // ESHOP BUSINESS
      {
        id: 5,
        name: 'offer_' + packs[4].name,
        price: this.getPrice(prices, 'pack', 5),
        optionList: [
          translate('Jusqu\'a <strong>$num$</strong> produits', { num: '50' }),
          translate('Modeles <strong>e-commerce</strong>')
        ],
        list: [
          {
            description: translate('Offre $offer$ incluse', { offer: 'e-Commerce Essential' }),
            img: 'pack_4'
          },
          {
            description: translate('Gestion des produits')
          },
          {
            description: translate('Gestion des livraisons')
          },
          {
            description: translate('Gestion de l\'inventaire'),
          },
          {
            description: translate('Paiements securises (Stripe, PayPal)'),
          },
        ],
        isStared: true,
      },
      // ESHOP PRO
      {
        id: 6,
        name: 'offer_' + packs[5].name,
        price: this.getPrice(prices, 'pack', 6),
        optionList: [
          translate('Jusqu\'a <strong>$num$</strong> produits', { num: '1000' }),
          translate('Modeles <strong>e-commerce</strong>')
        ],
        list: [
          {
            description: translate('Offre $offer$ incluse', { offer: 'e-Commerce Advanced' }),
            img: 'pack_5'
          },
          {
            description: translate('50+ systemes de paiement'),
            tooltip: 6,
          },
          {
            description: translate('Affichage des remises')
          },
          {
            description: translate('Enregistrement du panier'),
          },
          {
            description: translate('Gamme de produits'),
          },
          {
            description: translate('Vente sur mobile'),
          },
          {
            description: translate('Calcul des taxes'),
          },
          {
            description: translate('Frais de gestion'),
          },
        ],
        isStared: false,
      },
    ]
  }

  getSiteBuilderPeriodCards(prices: ISiteBuilderDynamicPrices, promos: ISiteBuilderCartPromos[]): ISiteBuilderPeriodCard[] {
    return [
      {
        id: 0,
        period: 1,
        periodNum: 1,
        pricePerMonth: this.getPrice(prices, 'period', 1),
        pricePerYear: this.getPrice(prices, 'period', 1, true),
        promo: null,
      },
      {
        id: 1,
        period: 12,
        periodNum: 1,
        pricePerMonth: this.getPrice(prices, 'period', 12),
        pricePerYear: this.getPrice(prices, 'period', 12, true),
        promo: promos.find(promo => promo.unit === 12),
      },
      {
        id: 2,
        period: 24,
        periodNum: 2,
        pricePerMonth: this.getPrice(prices, 'period', 24),
        pricePerYear: this.getPrice(prices, 'period', 24, true),
        promo: promos.find(promo => promo.unit === 24),
      },
      {
        id: 3,
        period: 36,
        periodNum: 3,
        pricePerMonth: this.getPrice(prices, 'period', 36),
        pricePerYear: this.getPrice(prices, 'period', 36, true),
        promo: promos.find(promo => promo.unit === 36),
      }
    ]
  }


  getPrice(prices: ISiteBuilderPrices | ISiteBuilderDynamicPrices, category: string, value: string | number, fixed: boolean = false): any {
    try {
      if (category === 'period') {
        const myPeriod = prices['period'].find(x => x.unit === value) as any;
        return (myPeriod && myPeriod.prices ? (fixed ?
          { amountVAT: myPeriod.prices.fixed.incl_vat, amountNoVAT: myPeriod.prices.fixed.excl_vat } :
          { amountVAT: myPeriod.prices.period.monthly.incl_vat, amountNoVAT: myPeriod.prices.period.monthly.excl_vat })
          : 'N/D');
      }
      if (category === 'pack') {
        const packId = value;
        const packPrices = prices['pack'][packId];
        const selectedPackPrice = packPrices.monthly;

        if (selectedPackPrice && selectedPackPrice.prices) {
          return fixed ? {
            amountVAT: selectedPackPrice.prices.fixed.incl_vat,
            amountNoVAT: selectedPackPrice.prices.fixed.excl_vat
          }
            : {
              amountVAT: selectedPackPrice.prices.period.monthly.incl_vat,
              amountNoVAT: selectedPackPrice.prices.period.monthly.excl_vat,
            };
        }
        return 'N/D';
      }

      const categoryPrices = prices[category].find((x: any) => x.unit === value).prices;
      return fixed ?
        { amountVAT: categoryPrices.fixed.incl_vat, amountNoVAT: categoryPrices.fixed.excl_vat } :
        { amountVAT: categoryPrices.period.monthly.incl_vat, amountNoVAT: categoryPrices.period.monthly.excl_vat };
    } catch (e) {
      console.error(e);
      return { amountVAT: null, amountNoVAT: null };
    }
  }
}
